function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.385,14.193c-0.605,0-1.096,0.49-1.096,1.096v3.289H5.422V8.711h3.289c0.605,0,1.097-0.491,1.097-1.097 S9.316,6.518,8.711,6.518H5.422c-1.211,0-2.192,0.981-2.192,2.192v9.868c0,1.21,0.981,2.192,2.192,2.192h9.867 c1.21,0,2.191-0.982,2.191-2.192v-3.289C17.48,14.683,16.991,14.193,16.385,14.193z M20.448,3.55 c-0.199-0.198-0.473-0.321-0.774-0.321h-5.481c-0.606,0-1.065,0.491-1.065,1.065c0,0.605,0.491,1.065,1.096,1.065h2.835 l-7.706,7.829c-0.429,0.429-0.429,1.122,0,1.55c0.428,0.432,1.124,0.432,1.552,0.002l7.675-7.769v2.836 c0,0.605,0.49,1.065,1.064,1.065c0.575,0,1.127-0.459,1.127-1.065V4.295C20.77,4.023,20.646,3.749,20.448,3.55z"
});

function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b4ab1caa.svg";
export { ForwardRef as ReactComponent };